// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#divPrincipal{
    text-align:center;
    background-color:#A9596E;
    min-height: 100%;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
}

h1{
    color: #FFFF;
    font-family: 'Dosis', sans-serif;
	font-size: 3.75rem;
	position: absolute;
    left: 50%;
    margin-left: -8.406rem;
}

#divCheckGeral{
	position: absolute;
	width: 14rem;
	left: 50%;
	margin-left: -7rem;
	height: 7rem;
	margin-top: -1.75rem;
	top: 40%;
}

.icon{
	width: 3.4rem;
	height: 3.4rem;
}

.divCheckIndividual{
	float:left;
	margin-right:0.81rem;
	margin-left:0.81rem;
	width: 3rem;
}

.regular-checkbox {
    appearance: none;
	-webkit-appearance: none;
	background-color: #79404F;
	border: 1px solid #FFFFFF;
	box-shadow: 0 3px 5px rgba(167, 40, 40, 0.521), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
	padding: 1.5rem;
	border-radius: 30px;
	display: inline-block;
	position: relative;
}

.regular-checkbox:active, .regular-checkbox:checked:active {
	box-shadow: 0 3px 5px rgba(167, 40, 40, 0.521), inset 0px 1px 3px rgba(0,0,0,0.1);
}

.regular-checkbox:checked {
    background-color: rgba(121, 64, 79, 0.685);
	box-shadow: 0 3px 5px rgba(87, 166, 57, 1), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1);
	color: #57A639;
}

.regular-checkbox:checked:after {
	content: '\\2714';
	font-size: 2.5rem;
	position: absolute;
	bottom: 0.1rem;
	margin-bottom: -0.5rem;
	left: 0.75rem;
	color: #57A639;
}

#divOK{
	position: absolute;
	width: 3.75rem;
	left: 50%;
	margin-left: -1.875rem;
	height: 3.75rem;
	margin-top: -1.875rem;
	top: 70%;
}

#btnOK{
	background-color: #F10F49;
	border-radius: 80px;
	padding: 1rem;
	color: #FFFFFF;
	margin-left: -0.5rem;
	margin-top: -1.75rem;
}

#btnRelatorio{
	background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
	outline:none;
	box-shadow: 0 0 0;
	position: absolute;
    right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/alimentacao/alimentacao.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,gCAAgC;CACnC,kBAAkB;CAClB,kBAAkB;IACf,SAAS;IACT,sBAAsB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,YAAY;CACZ,oBAAoB;CACpB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,UAAU;CACV,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;IACI,gBAAgB;CACnB,wBAAwB;CACxB,yBAAyB;CACzB,yBAAyB;CACzB,2FAA2F;CAC3F,eAAe;CACf,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,iFAAiF;AAClF;;AAEA;IACI,0CAA0C;CAC7C,oIAAoI;CACpI,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,sBAAsB;CACtB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,SAAS;CACT,sBAAsB;CACtB,eAAe;CACf,qBAAqB;CACrB,QAAQ;AACT;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,aAAa;CACb,cAAc;CACd,oBAAoB;CACpB,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;IAC1B,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IACd,gBAAgB;CACnB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;IACf,QAAQ;AACZ","sourcesContent":["#divPrincipal{\n    text-align:center;\n    background-color:#A9596E;\n    min-height: 100%;\n    width: 100%;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\nh1{\n    color: #FFFF;\n    font-family: 'Dosis', sans-serif;\n\tfont-size: 3.75rem;\n\tposition: absolute;\n    left: 50%;\n    margin-left: -8.406rem;\n}\n\n#divCheckGeral{\n\tposition: absolute;\n\twidth: 14rem;\n\tleft: 50%;\n\tmargin-left: -7rem;\n\theight: 7rem;\n\tmargin-top: -1.75rem;\n\ttop: 40%;\n}\n\n.icon{\n\twidth: 3.4rem;\n\theight: 3.4rem;\n}\n\n.divCheckIndividual{\n\tfloat:left;\n\tmargin-right:0.81rem;\n\tmargin-left:0.81rem;\n\twidth: 3rem;\n}\n\n.regular-checkbox {\n    appearance: none;\n\t-webkit-appearance: none;\n\tbackground-color: #79404F;\n\tborder: 1px solid #FFFFFF;\n\tbox-shadow: 0 3px 5px rgba(167, 40, 40, 0.521), inset 0px -15px 10px -12px rgba(0,0,0,0.05);\n\tpadding: 1.5rem;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.regular-checkbox:active, .regular-checkbox:checked:active {\n\tbox-shadow: 0 3px 5px rgba(167, 40, 40, 0.521), inset 0px 1px 3px rgba(0,0,0,0.1);\n}\n\n.regular-checkbox:checked {\n    background-color: rgba(121, 64, 79, 0.685);\n\tbox-shadow: 0 3px 5px rgba(87, 166, 57, 1), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1);\n\tcolor: #57A639;\n}\n\n.regular-checkbox:checked:after {\n\tcontent: '\\2714';\n\tfont-size: 2.5rem;\n\tposition: absolute;\n\tbottom: 0.1rem;\n\tmargin-bottom: -0.5rem;\n\tleft: 0.75rem;\n\tcolor: #57A639;\n}\n\n#divOK{\n\tposition: absolute;\n\twidth: 3.75rem;\n\tleft: 50%;\n\tmargin-left: -1.875rem;\n\theight: 3.75rem;\n\tmargin-top: -1.875rem;\n\ttop: 70%;\n}\n\n#btnOK{\n\tbackground-color: #F10F49;\n\tborder-radius: 80px;\n\tpadding: 1rem;\n\tcolor: #FFFFFF;\n\tmargin-left: -0.5rem;\n\tmargin-top: -1.75rem;\n}\n\n#btnRelatorio{\n\tbackground-color: Transparent;\n    background-repeat:no-repeat;\n    border: none;\n    cursor:pointer;\n    overflow: hidden;\n\toutline:none;\n\tbox-shadow: 0 0 0;\n\tposition: absolute;\n    right: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
